import { render, staticRenderFns } from "./cube-page.vue?vue&type=template&id=5d3c3dea&scoped=true&"
import script from "./cube-page.vue?vue&type=script&lang=js&"
export * from "./cube-page.vue?vue&type=script&lang=js&"
import style0 from "./cube-page.vue?vue&type=style&index=0&id=5d3c3dea&scoped=true&lang=less&"
import style1 from "./cube-page.vue?vue&type=style&index=1&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c3dea",
  null
  
)

export default component.exports